import D2C_ServiceWeb from './Web'

class D2C_ServiceVarnish extends D2C_ServiceWeb {
  static objectType = 'serviceType'
  static active = true
  static soon = true
  static order = 32
  static typeName = 'varnish'
  static typeTitle = 'Varnish'
  static color = '#1177bb'
  static methods = {
    ...D2C_ServiceWeb.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceWeb.fields,
    image: {
      ...D2C_ServiceWeb.fields.image,
      default: 'd2cio/varnish',
    },
  }
}

export default D2C_ServiceVarnish
